import { Route, useHistory } from "react-router-dom";
import { useEffect } from "react";
import { localStoreName } from "../../utils/constants";
import { AuthLayout, FormLayout, LandingLayout, MainLayout } from "../../components";

export const LayoutRoute = ({ Component, ...rest }) => {
    const userDetails = JSON.parse(localStorage.getItem(localStoreName)) ?? null ;
    const token = userDetails.token
    const history = useHistory()

    useEffect(() => {
        if(!token) {
          history.push('./login') 
        }
        //eslint-disable-next-line
      }, [])

    return (
        <Route
            {...rest}
            render={(props) => (
                <MainLayout>
                    <Component props={props} />
                </MainLayout>
            )}
        />
    )
};

export const AuthLayoutRoute = ({ Component, ...rest }) => {
    return (
        <Route
            {...rest}
            render={(props) => (
                <AuthLayout>
                    <Component props={props} />
                </AuthLayout>
            )}
        />
    )
};

export const LandingLayoutRoute = ({ Component, ...rest }) => {
    return (
        <Route
            {...rest}
            render={(props) => (
                <LandingLayout>
                    <Component props={props} />
                </LandingLayout>
            )}
        />
    )
};

export const FormLayoutRoute = ({ Component, ...rest }) => {
    return (
        <Route
            {...rest}
            render={(props) => (
                <FormLayout>
                    <Component props={props} />
                </FormLayout>
            )}
        />
    )
};